import React from 'react';

import MenuMobile from './MenuMobile/MenuMobile';
import MenuDesktop from './MenuDesktop/MenuDesktop';
import { MenuLink } from './Menu.interface';

import './Menu.css';

const menu = () => {
  const menuLinks: MenuLink[] = [
    { name: 'Novinky', link: '/novinky' },
    { name: 'Akce', link: '/akce' },
    { name: 'Kapela', link: '/kapela' },
    { name: 'Fotky', link: '/fotky' },
    { name: 'Diskografie', link: '/diskografie' },
    { name: 'Videa', link: '/videa' },
    { name: 'Suvenýry', link: '/suvenyry' },
    { name: 'Kontakt', link: '/kontakt' },
  ];

  return (
    <div>
      <div className="desktop">
        <MenuDesktop links={menuLinks} />
      </div>
      <div className="mobile">
        <MenuMobile links={menuLinks} />
      </div>
    </div>
  );
}

export default menu;